// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14a68ee7","927":"be386c50"}[chunkId] + ".chunk.js";
};